import '../../styles/theme/shared.scss'
import '../../styles/global.scss'
import Image from 'next/image'
import { Col, Container, Nav, Navbar, Row } from 'react-bootstrap'
import { Inter } from 'next/font/google'
import cn from 'classnames'
import React, { useEffect } from 'react'
import { captureException } from '@sentry/nextjs'

const inter = Inter({
  subsets: ['latin'],
  display: 'swap',
  variable: '--inter-font',
})

interface Properties {
  homeUrl: string
  title: string
  error: Error & {
    digest?: string
  }
}

export const SharedGlobalError: React.FC<Properties> = ({
  homeUrl,
  title,
  error,
}) => {
  useEffect(() => {
    console.error('Fatal error occurred')
    console.error(error)
    captureException(error)
  }, [error])

  return (
    <html className={cn(inter.className, 'h-100')}>
      <body className="d-flex flex-column h-100">
        <header className="d-flex justify-content-between align-items-center py-3 ps-4 border-bottom">
          <Navbar.Brand>
            <Nav.Link
              className="fs-6 d-flex justify-content-center align-items-center gap-2"
              href={homeUrl}
            >
              <Image
                src="/images/nlp_logo.svg"
                alt="NLPatent Logo"
                width={120}
                height={32}
                priority
              />
              <div>|</div>
              <div>{title}</div>
            </Nav.Link>
          </Navbar.Brand>
        </header>
        <main className="d-flex flex-column justify-content-center align-items-center flex-grow-1 secondary">
          <Container
            fluid
            className="d-flex flex-column justify-content-center align-items-center"
          >
            <Row className="w-100 justify-content-center">
              <Col xs={12} md={8} lg={6} className="text-center">
                <h1 className="display-5 fw-bold mb-3 fs-1">
                  Something went wrong!
                </h1>
                <p className="fs-5 mb-4">
                  Sorry, an unexpected error has occurred.
                  <br />
                  Please try refreshing the page.
                </p>
                <p className="fs-6 text-muted mb-4">
                  If the issue persists, contact us at{' '}
                  <a
                    href="mailto:support@nlpatent.com"
                    className="link-primary"
                  >
                    support@nlpatent.com
                  </a>
                  .
                </p>
              </Col>
            </Row>
          </Container>
        </main>
      </body>
    </html>
  )
}
